import React, { useEffect } from 'react';

import { history } from '@/utils/navigation.web';

import { usePortalContext } from './PortalContext';

interface IPortalGateProps {
  gateName: string;
}

export function PortalGate({ gateName }: IPortalGateProps): JSX.Element | null {
  const { gates, removeAllGate } = usePortalContext();

  useEffect(() => {
    const removeGateOnRouteChange = history.listen(() => {
      removeAllGate();
    });

    return () => {
      removeGateOnRouteChange();
    };
  }, [removeAllGate]);

  return <>{gates[gateName] || null}</>;
}
